import isEqual from 'lodash/isEqual'

const DEFAULT_SORT_ORDER = 'asc'
const DEFAULT_RANGE = [0, 9]

const setStaffs = (state, staffList) => {
  Object.assign(state, { staffList })
}

const setHealthCareTeam = (state, healthCareTeamList) => {
  Object.assign(state, { healthCareTeamList })
}

const setCategories = (state, categoryList) => {
  Object.assign(state, { categoryList })
}

const setStatuses = (state, statuses) => {
  Object.assign(state, { statuses })
}

const setLoading = (state, loading) => {
  Object.assign(state, { loading })
}

const setHealthEvents = (state, healthEvents) => {
  Object.assign(state, { healthEvents })
}

const setPaginatedHealthEvents = (state, healthEvents) => {
  Object.assign(state, {
    healthEvents: [...state.healthEvents, ...healthEvents]
  })
}

const setStopLoad = (state, stopLoad) => {
  Object.assign(state, { stopLoad })
}

const setHasErrorOnFetching = (state, hasErrorOnFetching) => {
  Object.assign(state, { hasErrorOnFetching })
}

const resetFiltersSortAndRange = state => {
  Object.assign(state, {
    filters: {},
    sortBy: 'due_date',
    sortOrder: DEFAULT_SORT_ORDER,
    range: DEFAULT_RANGE
  })
}

const setCurrentEvent = (state, currentEvent) => {
  Object.assign(state, { currentEvent })
}

const sanitizeFilters = (state, { filters, cleanFilters }) => {
  if (cleanFilters) {
    resetFiltersSortAndRange(state)
  } else if (
    Object.keys(filters).length > 0 &&
    !isEqual(state.filters, filters)
  ) {
    state.filters = filters
  } else {
    state.filters = filters
  }

  Object.assign(state, { filters })
}

const setSortBy = (state, sortBy) => {
  Object.assign(state, { sortBy, sortOrder: DEFAULT_SORT_ORDER })
}

const toggleSortOrder = state => {
  const sortOrder =
    state.sortOrder === DEFAULT_SORT_ORDER ? 'desc' : DEFAULT_SORT_ORDER
  Object.assign(state, { sortOrder })
}

const setRange = (state, range) => {
  Object.assign(state, { range })
}

const setFollowUpData = (state, followUpData) => {
  Object.assign(state, { followUpData })
}

const resetFollowUpData = state => {
  Object.assign(state, {
    followUpData: {
      channelReference: {},
      automaticFollowUp: false,
      fupType: {},
      channelFupId: null
    }
  })
}

const setPlannedFollowUps = (state, plannedFollowUps) => {
  Object.assign(state, { plannedFollowUps })
}

const updateHealthEventLocally = (state, data) => {
  const healthEvents = state.healthEvents.map(event =>
    event.id === data.id ? data : event
  )
  Object.assign(state, { healthEvents })
}

export default {
  setStaffs,
  setHealthCareTeam,
  setCategories,
  setStatuses,
  setLoading,
  setHealthEvents,
  setPaginatedHealthEvents,
  setStopLoad,
  sanitizeFilters,
  setSortBy,
  toggleSortOrder,
  setRange,
  setCurrentEvent,
  setFollowUpData,
  resetFollowUpData,
  setPlannedFollowUps,
  updateHealthEventLocally,
  setHasErrorOnFetching
}
